/* WORK SAMPLES — the upload the apply form never had.
   ───────────────────────────────────────────────────────────────────────────
   /pages/sell showed a dropzone with aria-hidden="true" and no file input
   behind it. An applicant read "5–10 high-resolution images of your strongest
   work" above a required-marked label and had no way to send one.

   Shopify's contact form still cannot carry a file. So the binary goes straight
   from this browser to Shopify's own storage through the Artists Studio app
   proxy — the same staged-upload path the Studio uses for artwork — and only
   the resulting links travel in the form, in a hidden field.

     1. POST /apps/studio/api/apply/stage      → per-file upload targets
     2. POST each binary to its target         → browser to Shopify, direct
     3. POST /apps/studio/api/apply/register   → file ids and preview urls

   PROGRESSIVE ENHANCEMENT, AND IT MATTERS HERE. Until this script runs, the
   file input is an ordinary picker that would submit nothing — worse than the
   old lie, because it would look like it worked. The dropzone is revealed only
   once this file is running, and the portfolio link remains the documented
   fallback for anyone it fails for. */
(function () {
  var MAX_FILES = 10;
  var MAX_BYTES = 20 * 1024 * 1024;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function init(root) {
    var api = root.getAttribute('data-rk-api') || '/apps/studio/api/apply';
    var input = root.querySelector('[data-rk-upload-input]');
    var zone = root.querySelector('[data-rk-dropzone]');
    var listEl = root.querySelector('[data-rk-upload-list]');
    var errEl = root.querySelector('[data-rk-upload-err]');
    var field = root.querySelector('[data-rk-upload-field]');
    var form = root.closest('form');
    if (!input || !zone || !field) return;

    var items = [];   /* {name, stored, size, state:'pending'|'up'|'done'|'bad', url, id, msg} */
    var busy = false;
    var batch = '';   /* the shared prefix the reviewer searches for */

    /* The control exists only from here on. Until this line runs the applicant
       sees the portfolio-link fallback, never an input that cannot deliver. */
    input.hidden = false;
    zone.hidden = false;
    var fallback = root.querySelector('[data-rk-upload-fallback]');
    if (fallback) fallback.hidden = true;

    function say(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }

    function render() {
      listEl.hidden = items.length === 0;
      listEl.textContent = '';
      items.forEach(function (it, i) {
        var li = document.createElement('li');

        if (it.url) {
          var img = document.createElement('img');
          img.className = 'rk-sell-upload-thumb';
          img.src = it.url; img.alt = '';
          li.appendChild(img);
        } else {
          var ph = document.createElement('span');
          ph.className = 'rk-sell-upload-thumb';
          li.appendChild(ph);
        }

        var name = document.createElement('span');
        name.className = 'rk-sell-upload-name';
        name.textContent = it.name;
        li.appendChild(name);

        var state = document.createElement('span');
        state.className = 'rk-sell-upload-state' +
          (it.state === 'done' ? ' ok' : it.state === 'bad' ? ' bad' : '');
        state.textContent = it.state === 'done' ? 'Uploaded'
          : it.state === 'bad' ? (it.msg || 'Failed')
          : it.state === 'up' ? 'Uploading…' : 'Waiting';
        li.appendChild(state);

        /* Removing is only offered when nothing is in flight: pulling a file
           out mid-upload would leave a registered image with no row to match. */
        if (!busy) {
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'rk-sell-upload-remove';
          rm.textContent = 'Remove';
          rm.setAttribute('aria-label', 'Remove ' + it.name);
          rm.addEventListener('click', function () {
            /* Revoke before dropping the row, or the blob stays in memory for
               the life of the page. */
            if (items[i] && items[i].local) { try { URL.revokeObjectURL(items[i].local); } catch (e) {} }
            items.splice(i, 1); sync(); render();
          });
          li.appendChild(rm);
        }
        listEl.appendChild(li);
      });
    }

    /* What the contact form carries. One line per image so the application
       email is readable by a person, which is the only thing that reads it.

       NOT BUILT ON THE PREVIEW URL. Shopify generates that after the file is
       registered, and not by a little — measured, it was still empty 25 seconds
       after the binary landed. So the email is built on the NAME: every image in
       one application shares a batch prefix, and the last line tells the
       reviewer exactly what to paste into Content → Files to see all of them
       together. The url is appended only when it happens to be ready. */
    function sync() {
      var done = items.filter(function (i) { return i.state === 'done'; });
      if (!done.length) { field.value = ''; return; }
      var lines = done.map(function (i) {
        return '· ' + (i.stored || i.name) + (i.url ? '  ' + i.url : '');
      });
      if (batch) {
        lines.push('');
        lines.push('Find these in Shopify admin → Content → Files, search: ' + batch);
      }
      field.value = lines.join('\n');
    }

    function post(path, body) {
      return fetch(api + '/' + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.message || j.error || ('http_' + r.status));
          return j;
        });
      });
    }

    function add(files) {
      say('');
      var picked = [];
      each(files, function (f) {
        if (items.length + picked.length >= MAX_FILES) return;
        if (!/^image\/(jpeg|png)$/.test(f.type)) {
          say('JPG or PNG only — ' + f.name + ' was not added.'); return;
        }
        if (f.size > MAX_BYTES) {
          say('Each image must be under 20MB — ' + f.name + ' is too large.'); return;
        }
        picked.push(f);
      });
      if (!picked.length) return;
      if (items.length + picked.length > MAX_FILES) {
        say('Up to ' + MAX_FILES + ' images.');
      }
      upload(picked);
    }

    function setBusy(v) {
      busy = v;
      zone.classList.toggle('is-busy', v);
      if (form) {
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.disabled = v;
      }
    }

    function upload(files) {
      var start = items.length;
      files.forEach(function (f) {
          /* THE THUMBNAIL COMES FROM THE FILE IN THIS BROWSER, not from Shopify.
           It was read from the url register returns, which is empty: Shopify
           generates previews asynchronously and — measured — still had not
           produced one 25 seconds after the upload. So every image showed a
           grey placeholder, for ever, and an applicant had no way to tell
           which file was which or whether the right ones went up.
           The browser is holding the bytes already. createObjectURL is instant,
           costs no request, and works whether or not Shopify ever catches up. */
        var local = '';
        try { local = URL.createObjectURL(f); } catch (e) { local = ''; }
        items.push({ name: f.name, size: f.size, state: 'pending', url: local, local: local });
      });
      setBusy(true); render();

      post('stage', {
        files: files.map(function (f) {
          return { filename: f.name, mimeType: f.type, fileSize: f.size };
        })
      }).then(function (res) {
        var targets = res.targets || [];
        batch = res.prefix || batch;
        (res.filenames || []).forEach(function (n, i) {
          if (items[start + i]) items[start + i].stored = n;
        });
        /* Sequential, not parallel: ten 20MB images at once is how a phone on a
           hotel connection loses all ten. */
        return files.reduce(function (chain, f, i) {
          return chain.then(function () {
            var t = targets[i];
            if (!t) throw new Error('stage_missing');
            items[start + i].state = 'up'; render();
            var fd = new FormData();
            (t.parameters || []).forEach(function (p) { fd.append(p.name, p.value); });
            fd.append('file', f);
            return fetch(t.url, { method: 'POST', body: fd }).then(function (r) {
              if (!r.ok) throw new Error('transfer_failed');
              items[start + i].resourceUrl = t.resourceUrl;
            });
          });
        }, Promise.resolve()).then(function () {
          return post('register', {
            resourceUrls: files.map(function (_, i) { return items[start + i].resourceUrl; })
          });
        });
      }).then(function (res) {
        (res.files || []).forEach(function (f, i) {
          var it = items[start + i];
          if (!it) return;
          it.state = 'done'; it.id = f.id || '';
          /* Only replace the local preview if Shopify actually produced one —
             assigning f.url unconditionally blanked a thumbnail that worked. */
          if (f.url) it.url = f.url;
        });
        sync(); setBusy(false); render();
      }).catch(function (e) {
        for (var i = start; i < items.length; i++) {
          if (items[i].state !== 'done') { items[i].state = 'bad'; items[i].msg = 'Failed'; }
        }
        say(e && e.message && e.message.indexOf('http_') !== 0
          ? e.message
          : 'The upload did not finish. Try again, or send a portfolio link instead.');
        sync(); setBusy(false); render();
      });
    }

    input.addEventListener('change', function () {
      add(input.files);
      /* Cleared so choosing the same file twice still fires a change event. */
      input.value = '';
    });

    ['dragenter', 'dragover'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) {
        e.preventDefault(); zone.classList.add('is-drag');
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) {
        e.preventDefault(); zone.classList.remove('is-drag');
      });
    });
    zone.addEventListener('drop', function (e) {
      if (busy) return;
      if (e.dataTransfer && e.dataTransfer.files) add(e.dataTransfer.files);
    });
    zone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); }
    });

    /* THE FORM MUST NOT LEAVE WHILE IMAGES ARE STILL IN FLIGHT. Submitting
       mid-upload sends an application whose most important field is half
       written, and the applicant has no way to tell.

       AND THE APPLICATION IS RECORDED BEFORE IT IS SENT. Shopify's contact form
       emails and stores nothing, so the curatorial console had no way to know
       anyone had applied — accepting an artist meant already knowing their
       address and finding it in an inbox. This posts the same fields to the app
       so they arrive as a row in a queue.

       THE EMAIL STILL GOES, WHATEVER HAPPENS HERE. If the record fails, times
       out, or the app is down, the form submits anyway: losing a row is a
       nuisance, losing an artist's twenty minutes is not. */
    var recorded = false;
    if (form) {
      form.addEventListener('submit', function (e) {
        if (busy) {
          e.preventDefault();
          say('Still uploading — one moment.');
          return;
        }
        if (recorded) return;          /* second pass, after the record */
        e.preventDefault();
        recorded = true;

        var val = function (n) {
          var el = form.querySelector('[name="contact[' + n + ']"]');
          return el ? el.value : '';
        };
        var done = items.filter(function (i) { return i.state === 'done'; });
        var payload = {
          email: val('email') || val('Email'),
          firstName: val('First name'), lastName: val('Last name'),
          heritage: val('Heritage connection'), aboutWork: val('About your work'),
          portfolio: val('Portfolio link'), social: val('Social link'),
          heard: val('How heard'),
          filePrefix: batch,
          fileNames: done.map(function (i) { return i.stored || i.name; }).join('\n'),
          /* THE FILE IDS TOO. Names alone meant a curator could only be told to
             go and look in Content → Files: the preview url is not ready at
             upload time, but it is by the time anyone reads the application, so
             the console resolves these and shows the work itself. */
          fileGids: done.map(function (i) { return i.id || ''; }).join('\n')
        };

        var go = function () { form.submit(); };
        var timer = setTimeout(go, 6000);   /* never hold the artist up */
        fetch(api + '/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        }).then(function () { clearTimeout(timer); go(); })
          .catch(function () { clearTimeout(timer); go(); });
      });
    }
  }

  function boot() {
    each(document.querySelectorAll('[data-rk-upload]'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
